import { storageAvailable } from './utils/bom-dom-manipulation/storage-available';
import {setAppConfigs, setCurrentPage, setLanguageConfigs} from "./utils/generic/global-variables";


if (!navigator.platform.includes('Mac')) {
  document.documentElement.classList.add('uc-scrollbar');
}

window.localStorageAvailable = (window.fromNext && window.localStorage) ||storageAvailable('localStorage')  ;
window.sessionStorageAvailable = (window.fromNext && window.sessionStorage) || storageAvailable('sessionStorage');
window.mustRefreshForSessionVisibility = false;

// prevents iOS Safari from caching the page, which causes different issues with the back button
// android devices operate correctly with the back button, because they reload the page
if ((/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) {
      document.body.style.display = "none";
      window.location.reload();
    }
  })
}

// This sets application configs from window in case of it is SpringBuilder X
if (!window.fromNext && window.partnerConfigs) {
  setAppConfigs(window.partnerConfigs);
}

// This sets application configs from window in case of it is SpringBuilder X
if (!window.fromNext && window.currentLanguageObject) {
  setLanguageConfigs(window.currentLanguageObject);
}

// This sets application configs from window in case of it is SpringBuilder X
if (!window.fromNext && window.page) {
  setCurrentPage(window.page);
}
